module.exports = __webpack_public_path__ + "img/ydd_dggp.89cde801.png";